<template>
    <component :is="customTag ?? 'span'" v-if="useRuntimeConfig().public.enableSmartLinks" :data-kontent-element-codename="codename">
        <slot></slot>
    </component>
    <template v-else>
        <component :is="customTag ?? 'span'">
        <slot></slot>
    </component>
    </template>
</template>
<script setup lang="ts">
const props = defineProps<{ codename: string, customTag?:string}>()
</script>